import React, { useEffect, useRef, useState } from "react";
import brands1 from '../assets/images/brands1.jpg';
import { Link } from "react-router-dom";
import logo from '../assets/images/logo.svg';
import Footer from "./Footer";
import TopNav from "./TopNav";
import LoaderView from "../tools/LoaderView";
import sia from "../services/Api";
import { notifySuccessful, notifySuccessfulMessage } from "../App";

const KhatmSalavat = (props) => {

    const [isLoading, setLoading] = useState(true)
    const [responseData, setResponseData] = useState()
    const [isLoadingShomaresh, setLoadingShomaresh] = useState(false);
    const [customNumber, setCustomNumber] = useState()
    const khatmId = useRef()

    useEffect(() => {
        const search = props.location.search
        const params = new URLSearchParams(search)
        khatmId.current = params.get('id')

        getData()
    }, [])

    const getData = async () => {
        setLoading(true)
        await sia.getDataFromServer('funeral/' + khatmId.current).then((res) => {
            if (res.status == 200) {
                const data = res.data
                data.shomarsh?.map((item) => {
                    data.prays?.forEach((pray) => {
                        if (pray._id == item.pray_id) {
                            pray.count = item.count
                        }
                    })
                })
                setResponseData(data)
            }
        }).catch((err) => console.error(err))
        setLoading(false)
    }

    const read = async (plusCount) => {
        setLoadingShomaresh(true)
        const prayId = 'صلوات'
        const shomaresh = responseData.shomarsh ?? []

        if (shomaresh.length == 0) {
            shomaresh.push({ pray_id: prayId, count: Number(plusCount) })
        } else {
            shomaresh.forEach((item) => {
                // if(item.pray_id == null){
                //     item.pray_id = prayId
                // }
                item.count + Number(plusCount)
            })
        }

        console.log('wegfewg:: ' + JSON.stringify(shomaresh))
        // return

        setLoadingShomaresh(true)
        const postBody = {
            shomarsh: shomaresh
        }
        await sia
            .PostDataToServer("/addToShomarsh/" + khatmId.current, postBody)
            .then((res) => {
                if (res.status == 200) {
                    responseData.shomarsh = shomaresh
                    setResponseData(responseData)
                    notifySuccessfulMessage('با موفقیت ثبت شد')
                }
            })
            .catch((err) => console.log(err));
        setLoadingShomaresh(false)
    };

    return (
        <>
            <header>
                <div className="pagewrapper slim2" id="header-slim">
                    <div className="container">
                        <TopNav />
                    </div>
                </div>
            </header>
            <div className="clear" />
            <div className="pagewrapper">
                <div className="container">
                    <h1 id="khatm-single-main-title">ختم صلوات</h1>
                </div>
            </div>
            {isLoading ? <LoaderView /> : <div>
                <div className="pagewrapper" id="statistics">
                    <div className="container">
                        <div className="left-col">
                            <div className="stat-item box-sizing">
                                <span>{responseData.repeat}</span>
                                تعداد کل
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{responseData.shomarsh && responseData.shomarsh.length > 0 ? responseData.shomarsh[0].count : 0}</span>
                                خوانده شده
                            </div>
                            <div className="stat-item box-sizing">
                                <span>{responseData.repeat - (responseData.shomarsh && responseData.shomarsh.length > 0 ? responseData.shomarsh[0].count : 0)}</span>
                                مانده
                            </div>
                        </div>
                    </div>
                </div>
                <div className="pagewrapper" id="khatm-hajat">
                    <div className="container">
                        <h2 className="hajat-title">حاجت از ختم</h2>
                        <p className="hajat-text box-sizing radius10">
                            {responseData.wish}
                        </p>
                    </div>
                </div>
                <div className="pagewrapper" id="khatm-sabt">
                    <div className="container">
                        <a href title onClick={() => read(1)} className="link-button radius10 box-sizing ease">ثبت صلوات</a>
                        <a href title onClick={() => read(10)} className="link-button radius10 box-sizing ease">ثبت 10 صلوات</a>
                        <a href title onClick={() => read(100)} className="link-button radius10 box-sizing ease">ثبت 100 صلوات</a>
                        <a href title onClick={() => read(500)} className="link-button radius10 box-sizing ease">ثبت 500 صلوات</a>
                        <div className="clear" />
                    </div>
                </div>
                <div className="pagewrapper" id="khatm-sabt-form-wrapper">
                    <div className="container">
                        <h2 className="sabt-title">وارد کردن به صورت دستی</h2>
                        <form action id="khatm-sabt-form" method="get">
                            <input type="text" name="count" placeholder="میزان صلوات خوانده شده را در اینجا وارد کنید" className="text box-sizing radius10" onChange={(e)=>setCustomNumber(e.target.value)} value={customNumber}/>
                            <input onClick={() => read(customNumber)} value="ارسال" className="submit box-sizing ease radius10" />
                        </form>
                    </div>
                </div>
                <div className="clear" />
                <Footer />
            </div>}
        </>
    );
}

export default KhatmSalavat;